"use strict";

exports.__esModule = true;
exports.TITLE_ELEMENT = exports.SORT = exports.DENSITY = exports.COLUMN_ALIGN = void 0;
var COLUMN_ALIGN = {
  start: 'start',
  end: 'end',
  center: 'center',
  justify: 'justify'
};
exports.COLUMN_ALIGN = COLUMN_ALIGN;
var DENSITY = {
  compact: 'compact',
  spacious: 'spacious'
};
exports.DENSITY = DENSITY;
var SORT = {
  ascending: 'ascending',
  descending: 'descending'
};
exports.SORT = SORT;
var TITLE_ELEMENT = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6'
};
exports.TITLE_ELEMENT = TITLE_ELEMENT;